import { useLayoutEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';

/**
 * Transizione di pagina: un velo di carta che sale e svela il contenuto.
 *
 * Solo entrata, niente AnimatePresence/exit: con mode="wait" la pagina
 * uscente restava montata durante l'animazione di uscita e si
 * ri-renderizzava già con i parametri della rotta nuova (useParams/
 * useLocation aggiornati), producendo falsi "non trovato" a metà
 * transizione. Lo scroll (cima al PUSH, ripristino al POP) resta a
 * ScrollRestoration, indipendente da questa animazione.
 */
export const PageTransition = ({ children }) => {
  const { pathname } = useLocation();
  const primoRender = useRef(true);

  useLayoutEffect(() => {
    primoRender.current = false;
  }, []);

  return (
    <motion.div
      key={pathname}
      initial={primoRender.current ? false : { opacity: 0, y: 14 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.42, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.div>
  );
};
